import { useAdvertFavoriteVisibleControl } from '@edikk-edikk/ui';
import { useFavoriteToggleContext } from '#baseMenu/components/controls/favorite-toggle';

const useHandlerClick = () => {
  const { isOpen, open, hide } = useAdvertFavoriteVisibleControl();
  const {
    AdvertFavoriteBottomSheet,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useFavoriteToggleContext();

  return () => {
    if (!isLoaded) {
      setIsLoadInProcess(true);
      AdvertFavoriteBottomSheet.load().then(() => {
        setIsLoaded(true);
        setIsLoadInProcess(false);
        open();
      });
      return;
    }

    if (isOpen) {
      hide();
    } else {
      open();
    }
  };
};

export { useHandlerClick };
